<template>
    <td class="tw:hidden tw:sm:table-cell">
      <div v-if="review?.reviewable?.image">
        <img :src="review?.reviewable?.image" width="50" height="50" />
      </div>
    </td>
    <td class="tw:align-middle">
      <a :href="review?.links?.show" :target="review?.links?.show ? '_blank': '_self'">
        <Rating :rating-value="review.rating"></Rating>
        <span class="tw:flex tw:gap-1 tw:items-center">
          <span class="tw:inline-block tw:truncate tw:max-w-[250px] tw:mt-1 tw:font-semibold">
            {{ review.lang.emoji }}
            {{ review.title}}
          </span>
        </span>
      </a>
    </td>
    <td class="tw:align-middle">
      <ReviewStatusBadge :status="review.status" :title="review.moderation_reasons?.join('\n')" />
    </td>
    <td class="tw:align-middle">
      <span class="d-block">
        <strong>{{ review?.reviewable?.name  }}</strong>
      </span>
      {{ review?.reviewable?.brand?.name  }}
    </td>
    <td class="tw:align-middle">
      <small class="d-block" v-if="review.reviewer">
        {{ review.reviewer?.firstname }}<br/>{{ review.reviewer?.lastname }}
      </small>
      <Alert v-else variant="warning" class="tw:mb-0">
        {{ $t('You are not authorized to view this review') }}
      </Alert>
    </td>
    <td class="tw:align-middle">
      {{ displayDate(review.created_at) }}
    </td>
    <td class="tw:align-middle">
      <div class="tw:flex tw:gap-2 tw:items-center">
        <Badge variant="zinc-light" class="tw:mb-0">
          <Tooltip :title="review.purchase ? $t('Ready to buy it') : $t('Not ready to buy it')">
            <ShoppingCartIcon :class="[
                'tw:size-5',
                review.purchase ? 'tw:text-green-600' : 'tw:text-zinc-300'
              ]" />
          </Tooltip>
        </Badge>

        <Badge variant="zinc-light" class="tw:mb-0">
          <Tooltip :title="review.recommended ? $t('Recommend to friends') : $t('Do not recommend to friends')">
            <MegaphoneIcon :class="[
                'tw:size-5',
                review.recommended ? 'tw:text-green-600' : 'tw:text-zinc-300'
              ]" />
          </Tooltip>
        </Badge>
      </div>
    </td>
</template>

<script setup>
import {displayDate} from "@/utils/date";
import ReviewStatusBadge from "./ReviewStatusBadge.vue";
import { defineProps } from 'vue';
import Rating from "@/components/Rating.vue";
import Alert from "@/components/ui/Alert.vue";
import { Badge } from "@/components/ui/badge";
import {
  MegaphoneIcon,
  ShoppingCartIcon,
} from '@lucide/vue'
import Tooltip from '@/components/ui/Tooltip.vue'

const props = defineProps({
  review: {
    required: true,
  },
});
</script>
